@if (item) {
	<app-accordeon
		[view]="'classic'"
		[isOpenable]="!!item.requestText || !!item.bankSolution"
		(toggle)="setViewedAppeal()"
	>
		<div
			class="appeal-block__header-block"
			title
			[id]="'appeal-block__header-block' + item.regNumber"
		>
			<span class="appeal__head-field appeal__head-field--image">
				@if (item.isFirstVisible) {
					<app-svg-exclamation-mark
						width="30px"
						heigth="30px"
					></app-svg-exclamation-mark>
				} @else {
					<app-svg-document-one-list
						width="30px"
						heigth="30px"
					></app-svg-document-one-list>
				}
			</span>

			@if (item.saveDate) {
				<span
					class="appeal__head-field appeal__head-field--date"
					title="Дата регистрации обращения"
				>
					{{ item.saveDate | date: 'dd.MM.yyyy' }}
				</span>
			}
			<span
				class="appeal__head-field appeal__head-field--number"
				[title]="'Регистрационный номер обращения: ' + item.regNumber"
			>
				{{ item.regNumber }}
			</span>
			@if (item.theme) {
				<section class="accordeon__title-text appeal__head-field appeal__head-field--title">
					<h2
						class="appeal__head-appeal-title"
						title="Тема обращения: {{ item.theme }}"
					>
						{{ item.theme }}
					</h2>
				</section>
			}
			@if (item.status) {
				<div
					class="appeal__head-field appeal__head-field--status"
					title="Статус обращения"
				>
					<span
						class="color-status"
						[ngClass]="{
							'color-status--done': item.status === considered,
							'color-status--in-progress': item.status !== considered,
						}"
					>
						{{ item.status }}
					</span>
				</div>
			}
		</div>
		<div
			class="appeal-block__content-block"
			content
		>
			@if (item.requestText) {
				<app-appeal-hiding-text
					class="content-block__request-text"
					[title]="'Текст обращения'"
					[text]="item.requestText"
				></app-appeal-hiding-text>
			}
			@if (item.bankSolution) {
				<app-appeal-hiding-text
					class="content-block__bank-solution"
					[title]="'Ответ от Банка'"
					[text]="item.bankSolution"
				></app-appeal-hiding-text>
			}

			<ul class="appeal-block__documents-list">
				@for (item of item.documents; track $index) {
					<li class="appeal-block__documents-list-item">
						<a
							class="appeal-block__documents-list-item-link"
							(click)="openFile(item.file)"
						>
							<app-svg-document-one-list
								width="30px"
								heigth="30px"
							></app-svg-document-one-list>
							{{ item.fileName }}
						</a>
						<!-- <app-appeal-document [document]="item"></app-appeal-document> -->
					</li>
				}
			</ul>
		</div>
	</app-accordeon>
}
